import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

const DEFAULT_FALLBACK = '/data-catalog'

/**
 * Returns a navigate-back function that falls back to a default route
 * when there is no browser history (e.g. file opened in a new tab).
 */
export function useNavigateBack(fallbackPath: string = DEFAULT_FALLBACK) {
  const navigate = useNavigate()

  return useCallback(() => {
    // React Router v6 stores the history index in state.
    // idx === 0 or undefined means there's no previous entry to go back to.
    const historyIdx = window.history.state?.idx
    if (typeof historyIdx === 'number' && historyIdx > 0) {
      navigate(-1)
    } else {
      navigate(fallbackPath, { replace: true })
    }
  }, [navigate, fallbackPath])
}
